/* Bocock add to cart, site wide.

   One handler for every add to cart on the store: homepage cards, the kit,
   collection pages, product pages. Nothing reloads, nothing opens over the page.
   A card slides in from the right with the product that was just added, and the
   header count ticks.

   HOW IT AVOIDS FIGHTING PRESTIGE. Both listeners run in the CAPTURE phase on
   document, which fires before anything bound to the form or the button, and both
   call stopImmediatePropagation. Prestige's own handler therefore never runs, so
   there is no possibility of the item being added twice or of its drawer sliding
   open. Racing another cart system is how you get double adds; the only safe move
   is to get there first and stop the event dead.

   ------------------------------------------------------------------------------
   THE BUY NOW BUG THIS FILE USED TO HAVE, WRITTEN DOWN SO IT IS NOT REINTRODUCED.

   Shopify's unbranded dynamic checkout button, the one Prestige renders from
   {{ form | payment_button }} and which reads BUY NOW, is not a special widget.
   It is an ordinary submit button named "checkout" sitting inside the same
   /cart/add product form as Add to Cart.

   The old click handler correctly recognised it and returned without touching the
   event. But returning from a click handler lets the NATIVE submit proceed, which
   fires a submit event, and the old submit handler had no matching exemption. It
   swallowed the submit and ran the plain add to cart path. So the exemption made
   in the click handler was silently undone one event later, and every Buy Now on
   the site behaved like Add to Cart.

   Any future edit that adds an exemption to one listener must add it to BOTH.
   ------------------------------------------------------------------------------

   THREE OUTCOMES, IN PRIORITY ORDER:

     1. HANDS OFF. Shopify's own payment controls: Shop Pay, Apple Pay, Google Pay,
        and the unbranded dynamic checkout button. Shopify managed. We never
        preventDefault on them, on either the click or the submit. Interfering
        breaks checkout outright.

     2. ADD THEN CHECKOUT. Any control we own that means checkout: data-bk-checkout
        or a visible label of Buy Now / Buy It Now / Checkout Now. The item is added
        over fetch FIRST, so we know it landed, and only then does the browser go to
        /checkout. Redirecting first and hoping the add completed is how carts
        arrive empty.

     3. ADD AND STAY. Everything else on a /cart/add form.

   IT NEVER REWRITES BUTTON TEXT. A Prestige product button can contain spans,
   icons and loading states, and replacing its contents would destroy them.
   Confirmation is a class plus the card, neither of which touches innerHTML.

   THE RESPONSE BODY RIDES ALONG in the bkcart:added event. Shopify returns the
   line item it just created, with title, image, quantity and price resolved, and
   the card is built from that rather than from the DOM. That is what makes the
   same card correct on a homepage tile and on a product page gallery without a
   single template specific selector.

   Quantity, variant and selling plan ride along automatically, because the payload
   is FormData built from the real form rather than fields picked by hand.

   DEBUG. Set window.BK_DEBUG = true in the console, then click. Every decision is
   logged with the element and the branch taken. */
(function () {
  /* Shopify owned controls. Never touched. The custom element names are included
     so that a click which retargets out of shadow DOM to the host still matches. */
  var SKIP = '.shopify-payment-button,' +
             '.shopify-payment-button__button,' +
             '[data-shopify="payment-button"],' +
             'shopify-accelerated-checkout,' +
             'shopify-accelerated-checkout-cart,' +
             '[data-bk-skip]';

  /* Visible labels that mean checkout, for buttons nobody annotated. Compared
     after whitespace is collapsed and case is dropped, so a button containing an
     icon span still resolves. */
  var CHECKOUT_WORDS = [
    'buy now',
    'buy it now',
    'checkout now',
    'buy now and checkout',
    'purchase now'
  ];

  var toast;
  var lastClick = null;
  var lastClickAt = 0;

  function log() {
    if (window.BK_DEBUG && window.console) {
      console.log.apply(console, ['[bk cart]'].concat([].slice.call(arguments)));
    }
  }

  function say(msg) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'bktoast';
      toast.setAttribute('role', 'alert');
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('on'); }, 3200);
  }

  function isAddForm(f) {
    if (!f || f.tagName !== 'FORM') return false;
    return (f.getAttribute('action') || '').indexOf('/cart/add') !== -1;
  }

  function isShopifyOwned(el) {
    return !!(el && el.closest && el.closest(SKIP));
  }

  /* Does this control mean "take me to checkout" rather than "add and stay"?
     Checked three ways, because the store carries three generations of button:
     the Shopify convention (name=checkout), an explicit opt in we control
     (data-bk-checkout), and a plain human label. */
  function wantsCheckout(el) {
    if (!el) return false;
    if (el.name === 'checkout') return true;
    if (el.value === 'checkout') return true;
    if (el.hasAttribute && el.hasAttribute('data-bk-checkout')) return true;
    var label = (el.textContent || el.getAttribute('aria-label') || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    return CHECKOUT_WORDS.indexOf(label) !== -1;
  }

  function checkoutUrl() {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    return root.replace(/\/$/, '') + '/checkout';
  }

  /* Which control caused this submit. e.submitter is the correct answer and is
     supported everywhere current, but it is undefined on older Safari, so fall
     back to the button clicked a moment ago on this same form. Getting this wrong
     is what turns a Buy Now into an Add to Cart, so it is worth the belt. */
  function submitterOf(e, form) {
    if (e.submitter) return e.submitter;
    if (lastClick && Date.now() - lastClickAt < 800) {
      var f = lastClick.form || (lastClick.closest ? lastClick.closest('form') : null);
      if (f === form) return lastClick;
    }
    return document.activeElement && document.activeElement !== document.body
      ? document.activeElement
      : null;
  }

  function send(form, btn, thenCheckout) {
    if (form.dataset.bkbusy === '1') return;
    form.dataset.bkbusy = '1';
    if (btn && btn.classList) btn.classList.add('bkloading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        form.dataset.bkbusy = '';
        if (!res.ok) {
          if (btn && btn.classList) btn.classList.remove('bkloading');
          say(res.body && res.body.description ? res.body.description : 'That one could not be added.');
          return;
        }

        /* Checkout intent. The add is confirmed, so it is now safe to leave. The
           loading class stays on deliberately: the button should read as busy right
           up until the page changes rather than flicking back to idle first. */
        if (thenCheckout) {
          log('add confirmed, going to checkout');
          window.location.href = checkoutUrl();
          return;
        }

        if (btn && btn.classList) {
          btn.classList.remove('bkloading');
          btn.classList.add('bkadded');
          setTimeout(function () { btn.classList.remove('bkadded'); }, 1600);
        }
        document.dispatchEvent(new CustomEvent('bkcart:added', {
          bubbles: true,
          detail: { from: btn || form, body: res.body }
        }));
        ['cart:refresh', 'cart:updated', 'cart:build'].forEach(function (n) {
          document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
        });
      })
      .catch(function () {
        form.dataset.bkbusy = '';
        if (btn && btn.classList) btn.classList.remove('bkloading');
        say('Something went wrong. Try again in a moment.');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button,input[type="submit"],a[data-bk-checkout]');
    if (!btn) return;

    lastClick = btn;
    lastClickAt = Date.now();

    /* 1. Shopify owned. Leave the event completely alone, and note that the submit
       handler below must do the same when this button's submit arrives. */
    if (isShopifyOwned(btn)) {
      log('skip, shopify owned', btn);
      return;
    }

    var form = btn.form || btn.closest('form');

    /* 2. Checkout intent on a button we own. */
    if (wantsCheckout(btn)) {
      /* Not on an add form. This is something like the cart page checkout button,
         which already works natively. Do not touch it. */
      if (!isAddForm(form)) {
        log('checkout intent on a non add form, native', btn);
        return;
      }
      log('checkout intent, add then redirect', btn);
      e.preventDefault();
      e.stopImmediatePropagation();
      send(form, btn, true);
      return;
    }

    /* 3. Add and stay. */
    if (btn.type === 'button' && !btn.classList.contains('bkatc')) return;
    if (!isAddForm(form)) return;
    log('add and stay', btn);
    e.preventDefault();
    e.stopImmediatePropagation();
    send(form, btn, false);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAddForm(form)) return;

    var sub = submitterOf(e, form);

    /* THE FIX. A Shopify payment control that was correctly waved through on click
       must also be waved through here, or its native submit gets swallowed and
       turned into a plain add to cart. This is the whole Buy Now bug. */
    if (isShopifyOwned(sub)) {
      log('submit skip, shopify owned', sub);
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    if (form.dataset.bkbusy === '1') return;

    var btn = sub || form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]');
    var toCheckout = wantsCheckout(sub);
    log('submit', toCheckout ? 'checkout intent' : 'add and stay', btn);
    send(form, btn, toCheckout);
  }, true);
})();
